module.exports = __webpack_public_path__ + "img/glcode-example.f80703e2.png";